export const PAYMENT_NAMES = {
  yappy: 'Yappy -',
  comercial: 'Cuenta a crédito',
  crédito: 'Tarjeta',
  puntos: 'Puntos Gordos:',
  regalo: 'Tarjeta de Regalo:',
  cmf: 'CMF',
  ach: 'Transferencia ACH:',
  pendiente: 'Pendiente de pago: ',
  'pendiente de pago (contado)': 'Pendiente de pago (Contado): ',
}

export const findPaymentNameKey = (
  paymentName,
  paymentNames = PAYMENT_NAMES
) => {
  const normalizedPaymentName = paymentName?.trim().toLowerCase()
  if (!normalizedPaymentName) return undefined

  return Object.keys(paymentNames)
    .filter(key => normalizedPaymentName.includes(key))
    .sort((firstKey, secondKey) => secondKey.length - firstKey.length)[0]
}

// export const paymentName = Object.freeze(names)
